import type { JSX } from "react";
import { useAtom } from "jotai";

import { CodFluxoEtapaStatus } from "@repo/graphql-types/graphql";

import { CertificateProceduresSubStep } from "@/components/flows/steps/council/components/certificate-procedures-sub-step";
import { ALL_PROFESSIONS, PROFESSION_CERTIFICATE_DESCRIPTION } from "@/components/flows/steps/council/utils/professions";
import { ProgressRoundedLayout } from "@/components/ui/layout/progress-rounded-layout";
import { councilStepAtom } from "@/lib/atoms/council-step-atom";
import { useFlowStepContext } from "@/lib/context/flow-step-context";
import { flattenToJsonString } from "@/lib/utils/flatten-to-json-string";
import { useSubStepNavigation } from "@/hooks/use-sub-step-navigation";

export const AestheticProceduresPage = (): JSX.Element => {
  const { step, nextStep, isLoading, progress } = useFlowStepContext();
  const { profession, professionName, councilNumber, councilAcronym, uf, procedures } = useAtom(councilStepAtom)[0];
  const { goToSubStep } = useSubStepNavigation();

  const resolvedProfessionName =
    professionName ?? ALL_PROFESSIONS.find((p) => p.value === profession)?.label ?? null;
  const resolvedCouncilAcronym =
    councilAcronym ?? ALL_PROFESSIONS.find((p) => p.value === profession)?.council ?? null;

  const certificateDescription =
    (profession ? PROFESSION_CERTIFICATE_DESCRIPTION[profession] : null) ??
    "Especialização na área estética realizada";

  return (
    <ProgressRoundedLayout progress={progress} onBack={() => { goToSubStep("terms"); }}>
      <CertificateProceduresSubStep
        professionDescription={certificateDescription}
        onSubmit={(certificateFileId) => {
          void nextStep({
            ...step,
            resposta: flattenToJsonString({ profession, professionName: resolvedProfessionName, councilNumber, councilAcronym: resolvedCouncilAcronym, uf, procedures, certificateFileId }),
            status: CodFluxoEtapaStatus.Concluido,
          });
        }}
        isLoading={isLoading}
        buttonText={step.configuracoes?.textoBotao ?? "Continuar"}
      />
    </ProgressRoundedLayout>
  );
};
